$(function () {
	$('#gHeader').addClass('white');

	$(window).on('scroll', function () {
		if ($(window).scrollTop() > $('#main').offset().top) {
			$('#gHeader').addClass('fix');
		} else {
			$('#gHeader').removeClass('fix');
		}
	}).trigger('scroll');

	$(window).on('resize', function () {
		$('#index .mainVisual').innerHeight($(window).height());
	}).trigger('resize');

	$('#index .pageBox .linkList').slick({
		centerMode: false,
		centerPadding: '0',
		variableWidth: true,
		arrows: true,
		dots: false,
		autoplay: false,
		pauseOnHover: false,
		pauseOnFocus: false,
		responsive: [{
			breakpoint: 897,
			settings: {
				variableWidth: false,
				arrows: false,
			}
		}],
	});

  $('#index .maker .makerList').slick({
		centerMode: false,
		centerPadding: '0',
		variableWidth: true,
		arrows: true,
		dots: false,
		autoplay: false,
		slidesToShow: 4,
		pauseOnHover: false,
		pauseOnFocus: false,
		infinite: false,
		responsive: [{
			breakpoint: 897,
			settings: {
				variableWidth: false,
				slidesToShow: 2,
			}
		}],
	});

	if (window.innerWidth < 897) {
		$('#index .product .linkList').slick({
			centerMode: false,
			centerPadding: '0',
			arrows: false,
			dots: false,
			autoplay: false,
			pauseOnHover: false,
			pauseOnFocus: false,
		});
	}
});